<template>
  <div class="delivery-options-wrapper" :class="{ 'border--error' : showSelectDeliveryOptionError }">
    <select v-model="cart.activeDeliveryOptionIndex"
      class="delivery-options" 
      @change="updateOption">
      <option
        v-for="(option, index) in cart.deliveryOptions"
        :key="index"
        :value="index"
      >
        {{ option.translated_title }}<template v-if="option.code != 'BLANK_DELIVERY_OPTION'"> - {{ formattedPrice(option.charge.amount) }}</template>
      </option>
    </select>
    <p class="delivery-description" v-if="activeDeliveryDescription.length > 0">
      {{ activeDeliveryDescription }}
    </p>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"
import Helpers from "@/util/helpers"

export default {
  name: "delivery-options",
  mixins: [Helpers],
  props: {
    showSelectDeliveryOptionError: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    this.updateActiveDeliveryOption(this.cart.activeDeliveryOptionIndex);
  },
  methods: {
    updateOption(event) {
      // we receive the value from @change as a string, but it is a string of an integer, e.g. "2"
      let val = parseInt(event.target.value)
      this.updateActiveDeliveryOption(val)
    },
    ...mapActions(['updateActiveDeliveryOption'])
  },
  computed: {
    ...mapState(['cart']),
    ...mapGetters(['activeDeliveryDescription'])
  }
}
</script>